import { useSearchParentSessionFeedback } from '@actions';
import { LoadingSpinner } from '@components/LoadingSpinner/LoadingSpinner';
import { useAuthState } from '@contexts/AuthContext';
import { useQueryParamsState } from '@hooks';
import SessionParentFeedbackTable from '@modules/Mentor/ParentFeedback/SessionParentFeedbackTable';
import { SESSION_DETAILS } from '@routes';
import { useHistory, useLocation } from 'react-router-dom';

const useQuery = () => new URLSearchParams(useLocation().search);

const ParentFeedback = () => {
  const { userId } = useAuthState();
  const query = useQuery();
  const history = useHistory();

  const sessionLimit = query.get('sessionLimit') || '10';
  const sessionPage = query.get('sessionPage') || '1';

  const [sessionSearchParams, setSessionSearchParams] = useQueryParamsState<any>({
    mentor: userId,
    sessionPage,
    sessionLimit,
  });

  const { data: sessionData, isLoading: isSessionLoading } = useSearchParentSessionFeedback({
    page: sessionSearchParams.sessionPage,
    limit: sessionSearchParams.sessionLimit,
    mentor: userId,
    sortBy: 'createdAt',
    sortOrder: 'desc',
  });

  const sessionPagination = {
    pageSize: sessionLimit !== null ? parseInt(sessionLimit) : 10,
    total: sessionData?.total,
    currentPage: sessionPage !== null ? parseInt(sessionPage) : 1,
    onCurrentPageChange: (currentPage: number) => {
      setSessionSearchParams({
        ...sessionSearchParams,
        sessionPage: currentPage,
      });
    },
    onPageSizeChange: (size: number) => {
      setSessionSearchParams({
        ...sessionSearchParams,
        sessionLimit: size,
        sessionPage: 1,
      });
    },
  };

  const handleViewSessionDetails = (sessionId: string) => {
    if (!sessionId) return;
    history.push(`${SESSION_DETAILS}/${sessionId}`);
  };

  return (
    <section className="laptop:ml-1 min-h-screen w-full pt-6 bg-surfaceBackground">
      <section className="max-w-[1564px] flex flex-col m-auto gap-6 p-4 tablet:p-6 laptop:px-24">
        <h1 className="flex justify-between font-raleway font-semibold text-2xl">
          Parent Feedback
        </h1>

        <section className="flex flex-col gap-6">
          {isSessionLoading ? (
            <div className="flex justify-center py-10">
              <LoadingSpinner size="large" />
            </div>
          ) : (
            <SessionParentFeedbackTable
              entries={sessionData?.enrollments}
              isLoading={false}
              pagination={sessionPagination}
              onViewSession={handleViewSessionDetails}
            />
          )}
        </section>
      </section>
    </section>
  );
};

export default ParentFeedback;
